export class CartNotes {
  constructor(element) {
    this.inputs = element.querySelectorAll('[data-cart-note]');
    this.initInputs();
  }

  initInputs() {
    this.inputs.forEach((input) => {
      input.addEventListener(
        'change',
        function (e) {
          const note = e.target.value.toString() || '';
          this.saveNotes(note);
        }.bind(this)
      );
    });
  }

  saveNotes(newNote) {
    window
      .fetch(`${window.theme.routes.cart}/update.js`, {
        method: 'post',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({note: newNote}),
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
